import { CircularProgress } from "@mui/material";
import { DivLoading } from "./style";

const Loading = () => {
  return (
    <DivLoading>
      <CircularProgress />
    </DivLoading>
  );
};

export default Loading;
